import { render, staticRenderFns } from "./syPcCom.vue?vue&type=template&id=3c7711f2&scoped=true"
import script from "./syPcCom.vue?vue&type=script&lang=js"
export * from "./syPcCom.vue?vue&type=script&lang=js"
import style0 from "./syPcCom.vue?vue&type=style&index=0&id=3c7711f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7711f2",
  null
  
)

export default component.exports